/**
 * Courier workspace (Brief 185) — the two-way agent↔human bridge. Courier is
 * an in-flow messaging product (ask_operator / notify_operator / message_agent
 * over MCP + the API); this surface is the billed-activity view.
 */
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { ActivityStream } from '@/components/ActivityStream';

export function CourierWorkspace() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">Courier</h1>
        <p className="text-muted-foreground">
          The two-way text bridge between your agents and you — Telegram, email,
          SMS, plus agent-to-agent messaging. Drive it from MCP (ask_operator /
          notify_operator) or the /v1/bridge API.
        </p>
      </header>

      <Card>
        <CardHeader>
          <CardTitle>Activity</CardTitle>
          <CardDescription>Your billed Courier messages, newest first.</CardDescription>
        </CardHeader>
        <CardContent>
          <ActivityStream baseQuery={{ product: 'bridge' }} />
        </CardContent>
      </Card>
    </div>
  );
}
